import classNames from "classnames/bind";
import React from "react";
import { Icon } from "../Icon";
import { Skeleton } from "../Skeleton";
import styles from "./Pagination.module.scss";
import type { PageControlsProps } from "./types";

const cx = classNames.bind(styles);

const PageControls = ({
  pageSize,
  total,
  page,
  onChange,
  hasNextPage,
  isLoading = false,
  isBusy = false,
}: PageControlsProps) => {
  const handlePageChange = (newPage: number) => {
    onChange({
      total,
      pageSize,
      page: Number(newPage),
      hasNextPage,
    });
  };

  const isTotalKnown = total && total > 0;

  return (
    <div className={cx("flex", "tight")}>
      {isTotalKnown ? (
        <Skeleton
          isLoading={isLoading}
          isBusy={isBusy}
        >
          <button
            title="Go to First Page"
            type="button"
            className={cx("button")}
            disabled={page === 1}
            onClick={() => handlePageChange(1)}
          >
            <Icon
              variant="caret-double-left"
              size={16}
              weight="regular"
            />
          </button>
        </Skeleton>
      ) : null}
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
      >
        <button
          title="Go to Previous Page"
          type="button"
          className={cx("button")}
          disabled={page === 1}
          onClick={() => handlePageChange(page - 1)}
        >
          <Icon
            variant="caret-left"
            size={16}
            weight="regular"
          />
        </button>
      </Skeleton>
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
      >
        <p className={cx("text", "page")}>{page}</p>
      </Skeleton>
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
      >
        <button
          title="Go to Next Page"
          type="button"
          className={cx("button")}
          disabled={isTotalKnown ? page >= total / pageSize : !hasNextPage}
          onClick={() => handlePageChange(page + 1)}
        >
          <Icon
            variant="caret-right"
            size={16}
            weight="regular"
          />
        </button>
      </Skeleton>
      {isTotalKnown ? (
        <Skeleton
          isLoading={isLoading}
          isBusy={isBusy}
        >
          <button
            title="Go to Last Page"
            type="button"
            className={cx("button")}
            disabled={page >= total / pageSize}
            onClick={() => handlePageChange(Math.ceil(total / pageSize))}
          >
            <Icon
              variant="caret-double-right"
              size={16}
              weight="regular"
            />
          </button>
        </Skeleton>
      ) : null}
    </div>
  );
};

export default PageControls;
